import React, { Component } from "react";
import Paper from "@material-ui/core/Paper";
// import mailBackSoa from "./mailBackSoa";
import { MAILBACK_URL } from ".";

import {
  MailBackSoaIcon,
  CASIcon,
  ELSSIcon,
  CGSIcon,
  GASIcon,
  networthIcon,
  mailbackRightarrow,
} from "../../../store/types/appEssentials";
import Image from "../../Image";

export default class MailBackInvestor extends Component {
  async componentDidMount() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  render() {
    return (
      <div className="mail-back-investor-modes-container">
        <div className="investor-title ">Mailback Requests - Investor</div>
        <div className="flex mailback-in" style={{ flexWrap: "wrap" }}>
          <RequestModes
            name="Mail Back SOA"
            image={MailBackSoaIcon}
            onClick={() =>
              this.props.history.push({
                pathname:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? MAILBACK_URL +
                      "/investor/investor-selection/mail-back-soa"
                    : MAILBACK_URL + "/investor/investor-selection",

                state:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? {
                        name: "mailBackSoa",
                        investorData: this.props.location.state.investorData,
                      }
                    : { name: "mailBackSoa" },
              })
            }
          />
          <RequestModes
            name="Consolidated Account Statement"
            image={CASIcon}
            onClick={() =>
              this.props.history.push({
                pathname:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? MAILBACK_URL +
                      "/investor/investor-selection/consolidated-account-statement"
                    : MAILBACK_URL + "/investor/investor-selection",
                state:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? {
                        name: "consolidated",
                        investorData: this.props.location.state.investorData,
                      }
                    : {
                        name: "consolidated",
                      },
              })
            }
          />
          <RequestModes
            name="ELSS Account Statement"
            image={ELSSIcon}
            onClick={() =>
              this.props.history.push({
                pathname:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? MAILBACK_URL + "/investor/investor-selection/ELSS"
                    : MAILBACK_URL + "/investor/investor-selection",
                state:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? {
                        name: "ELSS",
                        investorData: this.props.location.state.investorData,
                      }
                    : {
                        name: "ELSS",
                      },
              })
            }
          />
          {/* <RequestModes
            name="CAN Based Account Statement"
            image={CANIcon}
            onClick={() =>
              this.props.history.push({
                pathname:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? MAILBACK_URL + "/investor/investor-selection/CAN"
                    : MAILBACK_URL + "/investor/investor-selection",
                state:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? {
                        name: "CAN",
                        investorData: this.props.location.state.investorData,
                      }
                    : {
                        name: "CAN",
                      },
              })
            }
          /> */}
          <RequestModes
            name="Capital Gains Statement"
            image={CGSIcon}
            onClick={() =>
              this.props.history.push({
                pathname:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? MAILBACK_URL + "/investor/investor-selection/CGS"
                    : MAILBACK_URL + "/investor/investor-selection",
                state:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? {
                        name: "CGS",
                        investorData: this.props.location.state.investorData,
                      }
                    : {
                        name: "CGS",
                      },
              })
            }
          />
          <RequestModes
            name="Grandfathering Account Statement"
            image={GASIcon}
            onClick={() =>
              this.props.history.push({
                pathname:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? MAILBACK_URL + "/investor/investor-selection/GAS"
                    : MAILBACK_URL + "/investor/investor-selection",
                state:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? {
                        name: "GAS",
                        investorData: this.props.location.state.investorData,
                      }
                    : {
                        name: "GAS",
                      },
              })
            }
          />

          <RequestModes
            name="Networth Report"
            image={networthIcon}
            onClick={() =>
              this.props.history.push({
                pathname:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? MAILBACK_URL + "/investor/investor-selection/GAS"
                    : MAILBACK_URL + "/investor/investor-selection",
                state:
                  this.props.location.state &&
                  this.props.location.state.investorData
                    ? {
                        name: "Networth",
                        investorData: this.props.location.state.investorData,
                      }
                    : {
                        name: "Networth",
                      },
              })
            }
          />
        </div>
      </div>
    );
  }
}

export class RequestModes extends Component {
  render() {
    return (
      <Paper
        className="mail-back-soa-paper"
        style={{
          boxShadow: "0px 0px 4px 0px rgba(211,211,211,0.9)",
        }}
      >
        <div className="mail-back-modes-investor-image">
          <Image
            src={`${this.props.image}`}
            style={{ height: 35 }}
            alt={this.props.name}
          />
        </div>
        <div style={{ display: "flex", justifyContent: "space-around",padding:15}}>
          <div style={{ visibility: "hidden" }}>a</div>
          <div className="mail-back-investor-mode-sub-title">
            {this.props.name}
          </div>
          <div
            onClick={this.props.onClick}
            // className="transaction-status-cards-mailback"
          >
            <Image
              src={mailbackRightarrow}
              alt="next"
              style={{ height: 30, width: 30,marginTop:3 }}
            />
          </div>
        </div>
      </Paper>
    );
  }
}
